import React, { useState, useEffect } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { toBase64 } from 'src/utils/upload';

const useStyles = makeStyles(theme => ({
  input: {
    display: 'none'
  }
}));

export default function UploadPicker({
  title = 'Upload Image',
  onSelected = () => {},
  acceptType = 'image/*',
  setUploadStatus
}) {
  const classes = useStyles();

  const [uploadText, setUploadText] = useState(title);
  useEffect(() => {
    setUploadText(title);
  }, [title]);

  const uploadChange = async evt => {
    // Attempt to get upload request
    if (evt.target.files.length === 0) return;

    const file = evt.target.files[0];
    const split = file.name.split('.');
    const fType = split[split.length - 1];
    setUploadText(<CircularProgress />);
    setUploadStatus && setUploadStatus('Uploading');
    try {
      const base64 = await toBase64(file);
      if (!base64) {
        throw new Error('Base64 is undefined');
      }

      setUploadText(
        file.name.length > 25
          ? `${file.name.substring(0, 25)}....${fType}`
          : file.name
      );

      onSelected({
        base64: base64,
        fileType: fType,
        previewUrl: URL.createObjectURL(file)
      });
    } catch (err) {
      console.error(err);
      setUploadText('Unable to upload, please try again');
    }
  };

  const randomId = `random-${Math.random()}`;

  return (
    <>
      <input
        accept={acceptType}
        className={classes.input}
        id={'contained-button-file-' + randomId}
        onChange={uploadChange}
        type="file"
      />
      <label htmlFor={'contained-button-file-' + randomId}>
        <Button variant="contained" component="span">
          {uploadText}
        </Button>
      </label>
    </>
  );
}
